import React from 'react';
import { browserHistory } from 'react-router';
import * as actions from '../../redux/actions';
import KioskVersionSet from '../../model/KioskVersionSet';
import KioskDeploymentSetForm from '../KioskDeploymentSetForm';
import $ from 'jquery';

class KioskDeploymentSetEditPage extends React.Component {
  state = {
    statusMessage: '',
  };

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getKVSList());
  }

  handleEditFormSubmit = (values) => {
    const { dispatch, auth } = this.props;
    let loggedInUser = auth.user;
    values.updatedBy = loggedInUser.email;

    return dispatch(actions.updateKVS(new KioskVersionSet(values)))
      .then(() => {
        this.goBack();
      })
      .catch((e) => {
        this.setState({ statusMessage: e.message }, () => {
          let $statusMessage = $(this.refs.statusMessage);
          $statusMessage.removeClass('animated fadeIn');
          setTimeout(() => $statusMessage.addClass('animated fadeIn'), 200);
        });
      });
  };

  handleDeleteClick = (name, reason) => {
    let isY = window.confirm(`Delete "${name}" with reason: "${reason}"?`);
    if (!isY) {
      return Promise.resolve();
    }

    const { dispatch, auth } = this.props;
    let loggedInUser = auth.user;
    let updatedBy = loggedInUser.email;

    return dispatch(actions.deleteKVS(name, reason, updatedBy))
      .then(() => {
        this.goBack();
      })
      .catch((e) => {
        this.setState({ statusMessage: e.message }, () => {
          let $statusMessage = $(this.refs.statusMessage);
          $statusMessage.removeClass('animated fadeIn');
          setTimeout(() => $statusMessage.addClass('animated fadeIn'), 200);
        });
      });
  };

  goBack = () => {
    let { prevLocation } = this.props;
    // if last location from login page, go to home page
    if (prevLocation && /^\/(login|logout)/.test(prevLocation.pathname)) {
      browserHistory.push('/');
      return;
    }
    browserHistory.goBack();
  };

  render() {
    let { statusMessage } = this.state;
    let { kvsList, params, form } = this.props;
    let filteredList = kvsList.filter((kvs) => {
      return kvs.name === params.name;
    });
    let kvs = filteredList[0] || {};
    let initialValues = { ...kvs };
    initialValues.isCreate = false;
    initialValues.reason = '';

    return (
      <div className='kiosk-deployment-set-page'>
        <div className='title-row kiosk-deployment-set'>
          <div className='title-back cursor-pointer' onClick={this.goBack}>
            <i className='fa fa-chevron-left' />
          </div>
          <div className='title' style={{ paddingLeft: '10px' }}>
            Update Kiosk Deployment Set
          </div>
        </div>

        {statusMessage && (
          <div className='error-message-bar' ref='statusMessage'>
            <i className='fa fa-warning' /> {statusMessage}
          </div>
        )}
        <KioskDeploymentSetForm
          initialValues={initialValues}
          onSubmit={this.handleEditFormSubmit}
          onDelete={this.handleDeleteClick}
          onCancel={this.goBack}
          stateForm={form}
          kvsList={kvsList}
          lastUpdateReason={kvs.reason}
        />
      </div>
    );
  }
}

export default KioskDeploymentSetEditPage;



// WEBPACK FOOTER //
// ./src/components/pages/KioskDeploymentSetEditPage.js